import React from 'react';
import { Dropdown } from 'react-bootstrap'

import AppIcon from '../../../../icon/app.svg'
import ChatIcon from '../../../../icon/chat.svg'
import CalendarIcon from '../../../../icon/calendar.svg'
import EmailIcon from '../../../../icon/email.svg'
import ProfileIcon from '../../../../icon/profile.svg'

import styles from './styles.module.scss'
import { Link } from 'react-router-dom';

const stylesApp = {
  width: 70,
  height: 70,
};

const App: React.FC = () => {
  
  return (
    <Dropdown autoClose="outside">
      <Dropdown.Toggle className="p-0 mx-1" variant="white" id="dropdown-basic">
        <img src={AppIcon} alt="App" width={20} height={20} />
      </Dropdown.Toggle>

      <Dropdown.Menu align='end' className='pt-1 pb-1 g-0'>
        <div className="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
          <p className={styles.appHeaderText}>Web Apps</p>
          <Link to={'/'} className="text-muted">Edit</Link>
        </div>
        <div className={styles.dropdownItemWrap}>
          <Dropdown.Item eventKey="1" className='d-flex flex-column align-items-center justify-content-center' style={stylesApp}>
            <img src={ChatIcon} className={styles.icons} alt="Chat" width={20} height={20} />
            <span className={styles.appText}>Chat</span>
          </Dropdown.Item>
          <Dropdown.Item eventKey="2" className='d-flex flex-column align-items-center justify-content-center' style={stylesApp}>
            <img src={CalendarIcon} className={styles.icons} alt="Calendar" width={20} height={20} /> 
            <span className={styles.appText}>Calendar</span>
          </Dropdown.Item>
          <Dropdown.Item eventKey="3" className='d-flex flex-column align-items-center justify-content-center' style={stylesApp}>
            <img src={EmailIcon} className={styles.icons} alt="Email" width={20} height={20} /> 
            <span className={styles.appText}>Email</span>
          </Dropdown.Item>
          <Dropdown.Item eventKey="4" className='d-flex flex-column align-items-center justify-content-center' style={stylesApp}>
            <img src={ProfileIcon} className={styles.icons} alt="Profile" width={20} height={20} /> 
            <span className={styles.appText}>Profile</span>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>

  );
};

export default App
